import * as React from "react";
import { Button } from "@/components/ui/button";
import { getFriendlyErrorMessage } from "@/lib/api-client";
import { Empty } from "./Empty";
import { NOTIFY_VARIANT_TOKENS } from "./tokens";

interface QueryErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
  variant?: "card" | "inline";
}

// Estado padrão para "esta query falhou", usado no lugar de tratar erro de leitura
// como lista vazia/sem dados. `error` normalmente é `query.error`; `onRetry` normalmente é
// `query.refetch`.
export function QueryErrorState({
  error,
  onRetry,
  title = "Não foi possível carregar",
  variant = "card",
}: QueryErrorStateProps): React.ReactElement {
  const spec = NOTIFY_VARIANT_TOKENS.danger;
  const Icon = spec.icon;
  return (
    <Empty
      variant={variant}
      icon={<Icon className={spec.accentClass} />}
      title={title}
      description={getFriendlyErrorMessage(error)}
      action={
        onRetry ? (
          <Button size="sm" variant="outline" onClick={onRetry}>
            Tentar novamente
          </Button>
        ) : undefined
      }
    />
  );
}
